import { gql } from '@apollo/client';

import { TLaunchDarklySet } from '../../../../store/LaunchDarkly';

import { client } from '../../graphql';
import { getStartDateString } from '../utils';
import { ICreateDeviceRedesignParams } from './types';
import { buildOptionalFields, resolveAgcoMutation, resolveNonAgcoMutation } from './utils';

/**
 * Creates a device using the appropriate GraphQL mutation based on available data.
 */
export const createDeviceRedesign = async (
  launchDarkly: TLaunchDarklySet,
  accountId: string,
  params: ICreateDeviceRedesignParams,
) => {
  const { nonVinData, ownershipStartDate, condition } = params;

  if (!nonVinData) {
    throw new Error('Non-VIN data is required');
  }

  if (!ownershipStartDate) {
    throw new Error('Missing start date.');
  }

  const formattedOwnershipStartDate = getStartDateString(ownershipStartDate);
  const optionalFields = buildOptionalFields(condition, nonVinData.yearOfManufacture);

  const { mutationName, deviceParams } = nonVinData.brand?.isAgco
    ? resolveAgcoMutation(nonVinData)
    : resolveNonAgcoMutation(nonVinData);

  const mutation = gql`
    mutation {
      ${mutationName}(
        device: {
          accountId: "${accountId}",
          ${deviceParams},
          ownershipStartDate: "${formattedOwnershipStartDate}"${optionalFields ? `, ${optionalFields}` : ''}
        }
      ) {
        id
      }
    }
  `;

  await client(launchDarkly).mutate({ mutation });
};
